import { render } from "./ModalLibroMayorDetalle.vue?vue&type=template&id=e49e012e"
import script from "./ModalLibroMayorDetalle.vue?vue&type=script&lang=js"
export * from "./ModalLibroMayorDetalle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__